import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivateCheckboxComponent } from './activate.component';
import { CompletedCheckboxComponent } from './completedItem.component';
import { SelectModule } from 'ng-select';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule, ModalModule, TimepickerModule } from 'ngx-bootstrap';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SuccessModalComponent } from './components/success-modal/success-modal.component';
import { CommonModule } from '@angular/common';
import { WarningModalComponent } from './components/warning-modal/warning-modal.component';
import { DangerModalComponent } from './components/danger-modal/danger-modal.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: ( createTranslateLoader ),
        deps: [ HttpClient ]
      }
    }),
    ModalModule,
    NgbModule,
  ],
  declarations: [
    ActivateCheckboxComponent,
    CompletedCheckboxComponent,
    SuccessModalComponent,
    WarningModalComponent,
    DangerModalComponent
  ],
  exports: [
    ActivateCheckboxComponent,
    CompletedCheckboxComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SelectModule,
    AngularMultiSelectModule,
    NgbModule,
    BsDatepickerModule,
    ModalModule,
    TimepickerModule,
    SuccessModalComponent,
    OwlDateTimeModule,
    OwlNativeDateTimeModule
  ],
  entryComponents: [SuccessModalComponent,    WarningModalComponent,
    DangerModalComponent
]
})

export class SharedModule {
  constructor(private translate: TranslateService) {
    this.translate.use('en-us');
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/shared/shared.module.ts